import { render, staticRenderFns } from "./fullscreen-button.vue?vue&type=template&id=5e1a1eac"
import script from "./fullscreen-button.vue?vue&type=script&lang=js"
export * from "./fullscreen-button.vue?vue&type=script&lang=js"
import style0 from "./fullscreen-button.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports